module.exports = __webpack_public_path__ + "img/01_uk.271eebf4.svg";